<div
  class="item has-edit-button"
  *ngIf="componentType; else configureComponentBlock"
>
  <div *ngIf="!componentConfig">No component found for {{ componentType }}</div>
  <div *ngIf="isLoading">Loading...</div>
  <div *ngIf="errorMsg">Error loading data: {{ errorMsg }}</div>
  <ng-template #dynamicCmp></ng-template>
</div>
<ng-template #configureComponentBlock
  >Click to configure Overview Component</ng-template
>
